import type { BushingType, ParamName } from '@/types/bushing';

/** Axis pair definition for a single scatter chart. */
export interface PlotAxes {
  xCol: ParamName;
  yCol: ParamName;
}

/**
 * Plot axes configuration per bushing type.
 * Mirrors the Python logic:
 *  - A1/C1/B1: plot1 = (Cz, Torsion), plot2 = (Cz, Cx)
 *  - D1: plot1 = (Cz, Cy), plot2 = (Cz, Torsion)
 *  - BYD EV Voided: plot1 = (Cy, Cz), plot2 = (Cy, Cx)
 *  - BYD EV Solid: plot1 = (Cz, Cx), plot2 = (Cz, Cx)
 */
export const PLOT_AXES_CONFIG: Record<BushingType, [PlotAxes, PlotAxes]> = {
  A1: [
    { xCol: 'Cz', yCol: 'Torsion' },
    { xCol: 'Cz', yCol: 'Cx' },
  ],
  B1: [
    { xCol: 'Cz', yCol: 'Torsion' },
    { xCol: 'Cz', yCol: 'Cx' },
  ],
  C1: [
    { xCol: 'Cz', yCol: 'Torsion' },
    { xCol: 'Cz', yCol: 'Cx' },
  ],
  D1: [
    { xCol: 'Cz', yCol: 'Cy' },
    { xCol: 'Cz', yCol: 'Torsion' },
  ],
  'BYD EV Voided': [
    { xCol: 'Cy', yCol: 'Cz' },
    { xCol: 'Cy', yCol: 'Cx' },
  ],
  'BYD EV Solid': [
    { xCol: 'Cz', yCol: 'Cx' },
    { xCol: 'Cz', yCol: 'Cx' },
  ],
};
